<div class="chat-sessions-wrapper">
  <!-- Sessions failed to load, so the sidebar offers the retry here too. A locally created chat can exist
       while the full list is still unknown, so the failure becomes a banner above it rather than hiding it. -->
  <deo-panel-state
    *ngIf="!isShowingRuns && loadError && !isLoading"
    mode="error"
    title="Couldn't load chats"
    [message]="loadError"
    [compact]="true"
    [layout]="hasChats ? 'banner' : 'block'"
    (retry$)="retry$.emit()"
  ></deo-panel-state>

  <!-- Talking to an agent: its recorded runs stand in for the chats. Read-only rows on purpose — a run
       has no backend session to star, rename or delete. -->
  <div class="session-section" *ngIf="isShowingRuns">
    <div class="section-header">RUN HISTORY</div>
    <div class="session-list">
      <div
        class="chat-session"
        *ngFor="let run of agentRuns; trackBy: trackByRunId"
        [class.active]="selectedRunId === run.id"
        (click)="onSelectRun(run)"
        tabindex="0"
        (keydown.enter)="onSelectRun(run)"
      >
        <div class="session-content">
          <div class="session-title">{{ run.scenario }}</div>
          <div class="session-meta">
            <span class="session-date">{{ runDate(run) }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="session-empty" *ngIf="!agentRuns?.length">This agent has not recorded any runs yet.</div>
  </div>

  <!-- Starred Chats Section -->
  <div class="session-section" *ngIf="!isShowingRuns && starredSessions.length > 0">
    <div class="section-header">STARRED CHATS</div>
    <div class="session-list">
      <div
        class="chat-session"
        *ngFor="let session of starredSessions"
        [class.active]="currentSessionId === session.id"
        (click)="onSelectChat(session.id)"
        tabindex="0"
        (keydown.enter)="onSelectChat(session.id)"
      >
        <div class="session-content">
          <div class="session-title">{{ session.title }}</div>
          <div class="session-meta">
            <span class="artifact-count" *ngIf="getArtifactCount(session) > 0">
              <svg-icon src="assets/icons/files-content.svg" svgClass="files-content-icon" />
              {{ getArtifactCount(session) }}
            </span>
          </div>
        </div>
        <div class="session-actions session-actions-show-icons" *ngIf="canManage(session)">
          <button
            nz-button
            nzType="text"
            nzSize="small"
            type="button"
            class="star-btn"
            (click)="onToggleStar(session.id, $event)"
            [attr.aria-label]="session.isFavorite ? 'Unstar chat' : 'Star chat'"
            [attr.aria-pressed]="session.isFavorite"
          >
            <svg-icon [src]="session.isFavorite ? 'assets/icons/favorite-filled.svg' : 'assets/icons/favorite.svg'" aria-hidden="true" />
          </button>
          <gains-ellipsis-menu class="card-menu" [menuItems]="chatMenuItems" [dropdownWidth]="'200px'" (changeEvent)="onChatMenuAction($event, session)"></gains-ellipsis-menu>
        </div>
      </div>
    </div>
  </div>

  <!-- Recent Chats Section. Always shown when the load succeeded (an empty list still gets its header, as
       before); on a failure only when chats exist, so the block state stands alone. -->
  <div class="session-section" *ngIf="!isShowingRuns && (!loadError || recentSessions.length > 0)">
    <div class="section-header">RECENT CHATS</div>
    <div class="session-list">
      <div
        class="chat-session"
        *ngFor="let session of recentSessions"
        [class.active]="currentSessionId === session.id"
        (click)="onSelectChat(session.id)"
        tabindex="0"
        (keydown.enter)="onSelectChat(session.id)"
      >
        <div class="session-content">
          <div class="session-title">{{ session.title }}</div>
          <div class="session-meta">
            <span class="artifact-count" *ngIf="getArtifactCount(session) > 0">
              <svg-icon src="assets/icons/files-content.svg" svgClass="files-content-icon" />
              {{ getArtifactCount(session) }}
            </span>
          </div>
        </div>
        <div class="session-actions" *ngIf="canManage(session)">
          <button
            nz-button
            nzType="text"
            nzSize="small"
            type="button"
            class="star-btn"
            (click)="onToggleStar(session.id, $event)"
            [attr.aria-label]="session.isFavorite ? 'Unstar chat' : 'Star chat'"
            [attr.aria-pressed]="session.isFavorite"
          >
            <svg-icon [src]="session.isFavorite ? 'assets/icons/favorite-filled.svg' : 'assets/icons/favorite.svg'" aria-hidden="true" />
          </button>
          <gains-ellipsis-menu class="card-menu" [menuItems]="chatMenuItems" [dropdownWidth]="'200px'" (changeEvent)="onChatMenuAction($event, session)"></gains-ellipsis-menu>
        </div>
      </div>
    </div>
  </div>
</div>
